import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {AdminEntityService} from "../../admin/AdminEntityService";
import {
    LeaderboardConfig, ListLeaderboardResponse, LeaderboardConstraints,
    LeaderboardPayout, OperatorProgression
} from "../../../../generated/protocol";
import {injectable} from "inversify";

export const LEADERBOARD_SERVICE_NAME = "leaderboardService";

export interface LeaderboardService extends AdminEntityService<LeaderboardConfig> {
    getConstraints(): Promise<LeaderboardConstraints>;

    getPayout(id: string, periodStart: number): Promise<LeaderboardPayout>;

    disableLeaderboard(nameId: string, operatorId: number): Promise<{}>;

    enableLeaderboard(nameId: string, operatorId: number): Promise<{}>;

}

@injectable()
export class LeaderboardServiceImpl extends AbstractAdminEntityService<LeaderboardConfig, ListLeaderboardResponse> implements LeaderboardService {


    constructor() {
        super("/leaderboards");
    }

    getConstraints(): Promise<LeaderboardConstraints> {
        return this.http.doGet(this.entityPath + "/constraints");
    }

    getPayout(id: String, periodStart: number): Promise<LeaderboardPayout> {
        return this.http.doGet(this.entityPath + "/payout/" + id + "/" + periodStart);
    }

    disableLeaderboard(nameId: string, operatorId: number): Promise<OperatorProgression> {
        return this.http.doGet(this.entityPath + "/" + nameId + "/" + operatorId + "/false");
    }

    enableLeaderboard(nameId: string, operatorId: number): Promise<OperatorProgression> {
        return this.http.doGet(this.entityPath + "/" + nameId + "/" + operatorId + "/true");
    }


}


// WEBPACK FOOTER //
// ./src/app/service/poker/leaderboard/LeaderboardService.ts